import "./AboutUs.css"
import React from 'react'

const AboutUs = () => {
  return (
    <div className="about-container">
        <h1>Our History</h1>
        <p>Trippy is owned and managed by Trippy in Pvt. Ltd, a leading brand in web designing services and e-commerce solutions. Trippy in Pvt. ltd. is
counted for its expertise in web solutions and its top ranking business portol. Our invincible exportise and rich exporiance has raisad our spirit to
reach ahead from our client's expectation. Commendable success rote of other portals managed by Trippy is a live paradigm of our work
excellence.</p>
        <h1>Our Mission</h1>
        <p>Our mission is to touch the horizon where our capabilities may successfully meet with the requirements of our clients, that too with ultimate
transparency and cost-effectiveness.</p>
        <h1>Our Vision</h1>
        <p>To sow the seeds of par-excellence services with customer centric approach and reap the trust of worldwide clients.</p>
    </div>
  )
}

export default AboutUs
